// frontend/src/pages/public/Terms/TermsContent.ts

export const termsPage = {
eyebrow: "Legal",
title: "Terms of Use",
subtitle: "Please read these terms carefully before using AcceptingMD.",

// ✅ No illustrations shipped yet (keep empty to avoid missing asset paths)
illustrationSrc: "",

sections: [
{
title: "About AcceptingMD",
body: [
"AcceptingMD is a digital connection platform designed to help individuals discover and connect with family doctors, clinics, and related healthcare access supports.",
"AcceptingMD does not provide medical care, medical advice, diagnosis, treatment, emergency services, or clinical triage. The platform facilitates discovery, connection, request submission, and workflow support only.",
"All healthcare services are delivered independently by third-party clinics, physicians, and other healthcare providers.",
],
},
{
title: "No Medical Advice",
body: [
"Information presented on AcceptingMD is for general informational purposes only.",
"Nothing on this platform should be considered medical advice. AcceptingMD does not make clinical recommendations, clinical decisions, attachment decisions, or appointment decisions.",
"You should always seek advice directly from a qualified healthcare professional regarding your medical condition.",
"Do not use AcceptingMD for emergencies or urgent medical concerns. In case of emergency, call 911 or go to the nearest emergency department.",
],
},
{
title: "Patient Requests and Intake Decisions",
body: [
"When you submit a patient request through AcceptingMD, your request is sent to the selected clinic or provider for review.",
"Clinics independently review, accept, decline, waitlist, invite, or otherwise respond to requests based on their own capacity, policies, eligibility criteria, and intake processes.",
"Submission of a request does not guarantee acceptance, attachment, appointment booking, or a response within a specific timeframe.",
"AcceptingMD has no control over clinic decisions, clinic capacity, clinic timelines, provider availability, attachment outcomes, appointment availability, or clinical care.",
"Clinics may contact you directly with next steps after reviewing your request.",
],
},
{
title: "Platform Rules for Patient Requests",
body: [
"By using the platform, you acknowledge and agree that:",
"• You must provide accurate information when submitting a request",
"• You should not include detailed medical history, urgent symptoms, medical records, lab results, diagnostic reports, or emergency concerns in the public patient request form",
"• You may submit requests to multiple doctors at different clinics where the platform workflow allows this",
"• You cannot submit multiple active requests to doctors within the same clinic at the same time",
"• Once accepted by one doctor or clinic, other pending requests may be automatically closed or cancelled according to platform workflow rules",
"• You may cancel your request using the “Check Status” or manage-request link where that workflow is available",
"• Requests may expire after 7 days if no clinic response is recorded",
"• Expiry means the request is no longer active for that clinic workflow; it does not necessarily mean the underlying record is immediately deleted",
],
},
{
title: "Provider Information",
body: [
"Healthcare providers and clinics control their own profiles, including services offered, clinic hours, acceptance of new patients, referral criteria, availability, and wait times where applicable.",
"AcceptingMD does not verify or guarantee the accuracy, completeness, availability, or timeliness of provider-submitted or clinic-submitted information.",
"Provider information may change without notice.",
],
},
{
title: "Privacy and Data Handling",
body: [
"AcceptingMD is designed to be privacy-respectful and to minimize the collection of personal health information.",
"No clinical medical records are exchanged through the public patient request form. Only limited personal information required for discovery, connection, request processing, verification, clinic review, and support is collected.",
"Request information may be shared with the clinic or provider you select so they can review and respond to your request.",
"Request expiry, cancellation, decline, waitlist, invitation, or completion does not necessarily mean the underlying platform record is immediately deleted.",
"Records may be retained for a defined period for workflow, audit, support, privacy, security, legal, clinic accountability, and operational purposes.",
"For full details, please review our Privacy Policy.",
],
},
{
title: "Acceptable Use",
body: [
"You agree not to:",
"• Submit false, misleading, incomplete, or unauthorized information",
"• Submit a request for another person unless you are authorized to do so",
"• Use the public request form for emergencies, urgent medical concerns, or detailed medical documentation",
"• Attempt to access restricted areas of the platform",
"• Attempt to access another person’s request, token, status link, or account",
"• Use the platform for commercial solicitation or spam",
"• Interfere with platform security, integrity, availability, or functionality",
"AcceptingMD reserves the right to suspend or restrict access for misuse.",
],
},
{
title: "No Warranty",
body: [
"AcceptingMD is provided on an “as-is” and “as-available” basis.",
"We make no guarantees regarding provider availability, clinic capacity, response times, request acceptance, attachment outcomes, appointment availability, accuracy of third-party information, or uninterrupted platform access.",
],
},
{
title: "Limitation of Liability",
body: [
"To the maximum extent permitted by law, AcceptingMD shall not be liable for any damages arising from your use of the platform, including denied requests, delayed care, clinic or provider decisions, third-party actions, inaccurate third-party information, or inability to access the platform.",
],
},
{
title: "Changes to These Terms",
body: [
"We may update these Terms of Use from time to time. Updates will be posted on this page.",
"Continued use of the platform after changes are posted constitutes acceptance of the updated terms.",
],
},
{
title: "Contact",
body: [
"If you have questions about these Terms of Use, please contact us through the platform’s contact page.",
],
},
],

ctas: {
title: "Continue using AcceptingMD",
subtitle: "You can return to care search or review our privacy practices at any time.",
primary: { label: "Find a Family Doctor", to: "/public/find-family-doctor" },
secondary: { label: "Privacy Policy", to: "/public/privacy" },
},
};
